<script setup lang="ts">
/**
 * EmptyLayout — chromeless container.
 *
 * No sidebar, no topbar, no global overlays beyond toasts.
 * Use for full-bleed screens like print views, embed widgets,
 * OAuth callbacks, or marketing landing pages.
 */
import { RouterView } from 'vue-router'
import { ToastStack, ErrorBoundary } from '@/components/ui'
</script>

<template>
  <div class="empty-shell">
    <ErrorBoundary>
      <Suspense>
        <RouterView v-slot="{ Component, route }">
          <component :is="Component" :key="route.path" />
        </RouterView>
        <template #fallback>
          <div style="min-height: 100vh"></div>
        </template>
      </Suspense>
    </ErrorBoundary>
    <ToastStack />
  </div>
</template>

<style scoped>
.empty-shell {
  min-height: 100vh;
  background: var(--color-bg-page);
}
</style>
